import { PaletteColor } from 'Modules/ui3';

import { EmissionItem, EmissionStatus } from '../../api';


export const statusColor: Record<EmissionItem['status'], { text: PaletteColor, border: PaletteColor }> = {
    [EmissionStatus.acception]: {
        border: 'infoCustom.orange60',
        text: 'infoCustom.orange60',
    },
    [EmissionStatus.active]: {
        border: 'infoCustom.green60',
        text: 'infoCustom.green60',
    },
    [EmissionStatus.closed]: {
        border: 'grayscale.shade60',
        text: 'grayscale.shade95',
    },
    [EmissionStatus.other]: {
        border: 'grayscale.shade60',
        text: 'grayscale.shade95',
    },
    [EmissionStatus.failed]: {
        border: 'grayscale.shade60',
        text: 'grayscale.shade95',
    },
    [EmissionStatus.upcoming]: {
        border: 'infoCustom.orange60',
        text: 'infoCustom.orange60',
    },
    [EmissionStatus.processing]: {
        border: 'infoCustom.orange60',
        text: 'infoCustom.orange60',
    },
};
